















































import { Component, Vue, Prop, Ref, Watch } from "vue-property-decorator";
import { Getter, Action } from "vuex-class";
import { FormRowWings, TextareaWings } from "wings-ui-components";
import { notifyError } from '@/utils/notify-helper';
import { MsgTransports } from '@/store/types';
import { email } from 'vee-validate/dist/rules';

@Component({ components: { FormRowWings, TextareaWings } })
export default class Recipients extends Vue {
  @Prop() distribution!: any;
  @Prop() transport!: MsgTransports;

  @Ref('validator') validator:any;

  @Getter("addressBooks") addressBooksList: any;

  @Action("getAddressBooks") actionGetAddressBooks: any;

  recipients = ''
  checkDuplicates = true
  checkDuplicatesPolicy = 3
  TRANSPORT_PUSH = MsgTransports.PUSH

  async created() {
    if (this.transport == this.TRANSPORT_PUSH) this.checkDuplicates = false
    try {
      await this.actionGetAddressBooks()
    } catch(error) {
      notifyError(error);
    }
  }

  getState() {
    return {
      groupsId: this.distribution.groupsId,
      recipient: this.distribution.recipient,
      recipients: this.recipients,
    }
  }

  setState(state: any = null) {
    if (state) {
      if (state?.groupsId) this.distribution.groupsId = state.groupsId
      if (state?.recipient) this.distribution.recipient = state.recipient
      if (state?.recipients) this.recipients = state.recipients
      return
    }
    this.distribution.groupsId = []
    this.distribution.recipient = []
    this.recipients = ''
  }

  get recipientsLabel() {
    return this.transport == MsgTransports.EMAIL ? this.$t('distribution.email.recipientsLabel') : this.$t('distribution.recipientsLabel')
  }

  get totalRecipients() {
    return this.groupContacts + this.recipientsCount
  }

  get recipientsCount() {
    this.distribution.recipient = this.recipients.split(',').map(item => item.trim()).filter(item => item != '')
    return this.distribution.recipient.length
  }

  get recipientsText() {
    // Всего получателей - %contacts%, Введено вручную - %manual%, Выбрано групп - %groups%, Получателей в группах - %group_contacts%
    return this.$t('distribution.recipientsCount', {
      contacts: this.totalRecipients,
      manual: this.recipientsCount,
      groups: this.distribution.groupsId.length,
      group_contacts: this.groupContacts
    })
  }

  get groupContacts() {
    let count = 0
    this.distribution.groupsId.forEach((id:any) => {
      count += this.addressBooksList.find((item: any) => item.id == id)?.contacts
    })
    return count
  }

  get isPhoneNumbers() {
    return [MsgTransports.SMS, MsgTransports.PUSH, MsgTransports.MAILNOTIFY].includes(this.transport)
  }

  async validate() {
    if (!this.totalRecipients) {
      notifyError(null, null, this.$t('distribution.messages.emptyRecipients').toString())
      return false
    }
    if (!await this.validator.validate()) {
      notifyError(null, this.validator.errors)
      return false
    }
    if (this.isPhoneNumbers) {
      let error = false
      this.distribution.recipient.forEach((item:string) => {
        if (item.length < 2 || item.length > 18) {
          notifyError(null, null, this.$t('distribution.messages.incorrectNumber').toString() + ' ' + item)
          error = true
        }
      })
      if (error) return false
    }
    if (this.transport == MsgTransports.EMAIL) {
      let error = false
      this.distribution.recipient.forEach((item:string) => {
        if (!email.validate(item)) {
          notifyError(null, null, this.$t('distribution.messages.incorrectEmail').toString() + ' ' + item)
          error = true
        }
      })
      if (error) return false
    }
    return true
  }

  get showAddressBooks() {
    return this.addressBooksList.length
  }

  @Watch('checkDuplicates', {immediate: true})
    onChangeCheckDuplicates(val?: boolean) {
      if (!val) {
        this.checkDuplicatesPolicy = 0
      } else {
        this.checkDuplicatesPolicy = 3
      }
    }
}
